
import { css } from 'lit';
export default css`
.carousel.carousel--story .splide__pagination{
  position:relative;
  margin:0 0 40px 0;
  margin-left:var(--spacing-20);
}

.carousel--slide-without-image.splide{
  padding-bottom:var(--spacing-14);
}

@media (min-width: 992px){
  .carousel.carousel--story .splide__pagination{
    position:absolute;
    bottom:95px;
    left:0;
    margin-top:0;
    margin-left:0;
    width:60%;
    display:flex;
    justify-content:flex-end;
  }

  .carousel--slide-without-image.splide{
    padding-bottom:0;
  }

  .carousel.carousel--story .carousel--slide-without-image .splide__pagination{
    bottom:130px;
    left:calc(33.33% / 2 + 4px + var(--spacing-8));
  }
}
`;